import { api } from "./BackendService";

export const create = (data) => api.post("/banners", data);
export const edit = (id, data) => api.put(`/banners/${id}`, data);
export const getById = (id) => api.get(`/banners/${id}`);
export const remove = (id) => api.delete(`/banners/${id}`);
export const list = (page) => api.get("/banners", { params: { page: page } });
